<template>
    <span
        v-if="type == 'success'"
        class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 mr-2 mb-2"
        >{{ value }}</span
    >
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
    },
};
</script>
